import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTubeStraight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 4000 4000",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeLinejoin: "round",
		strokeMiterlimit: 2
	},
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "matrix(-0.79066,0.79066,-0.56704,-0.56704,4867.88,1400.28)",
		children: [/* @__PURE__ */ _jsx("g", {
			transform: "matrix(2.01354,0,0,6.41952,-2175.39,-19789.9)",
			children: /* @__PURE__ */ _jsx("path", { d: "M1293.95,3296.42L3066.93,3296.42C3245.58,3366.74 3248.08,3432.07 3066.93,3492.21L1293.95,3492.21L1293.95,3296.42ZM1404.99,3344.98L1404.99,3443.65C1787.62,3443.65 3027.92,3443.65 3027.92,3443.65C3067.06,3428.92 3090.97,3414.72 3090.82,3398.34C3090.64,3380.46 3064.93,3363.47 3022.8,3344.98L1404.99,3344.98Z" })
		}), /* @__PURE__ */ _jsxs("g", {
			transform: "matrix(1,0,0,1.26731,-507.823,721.195)",
			children: [/* @__PURE__ */ _jsx("ellipse", {
				cx: 937.849,
				cy: 1009.07,
				rx: 315.994,
				ry: 495.894,
				style: { fill: "white" }
			}), /* @__PURE__ */ _jsx("path", { d: "M937.849,513.179C1112.25,513.179 1253.84,735.382 1253.84,1009.07C1253.84,1282.76 1112.25,1504.97 937.849,1504.97C763.447,1504.97 621.855,1282.76 621.855,1009.07C621.855,735.382 763.447,513.179 937.849,513.179ZM937.849,631.257C883.852,631.257 837.744,670.693 802.325,726.277C756.259,798.568 729.174,898.862 729.174,1009.07C729.174,1119.28 756.259,1219.58 802.325,1291.87C837.744,1347.45 883.852,1386.89 937.849,1386.89C991.847,1386.89 1037.95,1347.45 1073.37,1291.87C1119.44,1219.58 1146.53,1119.28 1146.53,1009.07C1146.53,898.862 1119.44,798.568 1073.37,726.277C1037.95,670.693 991.847,631.257 937.849,631.257Z" })]
		})]
	})
});
export default SvgTubeStraight;
